import { BaseModel } from "model/BaseModel";
import Local from "./Local";
import Produto from "model/administracao/cadastro/produto/Produto";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Arquivo from "model/arquivo/Arquivo";
import ItemNotaFiscalEntrada from "model/suprimentos/ItemNotaFiscalEntrada";
import { BaseEditModel } from "model/BaseEditModel";

export default class Patrimonio implements BaseModel, BaseEditModel {

    id: number;
    codigo: string;
    key: string;
    sequencial: number | null;
    status: string;
    preco: number;
    dataRecebimento: Date | null;
    local: Local | null;
    fornecedor: Pessoa | null;
    produto: Produto;
    cdProduto: string | null;
    arquivos: Arquivo[];
    observacao: string;
    observacaoInutilizavel: string;
    numeroSerie: string;
    modelo: string;
    numeroNotaFiscal: number | null;

    constructor(
        id = 0,
        codigo = "",
        key = "",
        sequencial = 0,
        status = "DISPONIVEL",
        preco = 0.00,
        dataRecebimento = new Date(),
        local = null,
        fornecedor = null,
        produto = new Produto(),
        cdProduto = "",
        arquivos = [],
        observacao = "",
        observacaoInutilizavel = "",
        numeroSerie = "",
        modelo = "",
        numeroNotaFiscal = null,
    ) {
        this.id = id;
        this.codigo = codigo;
        this.key = key;
        this.sequencial = sequencial;
        this.status = status;
        this.preco = preco;
        this.dataRecebimento = dataRecebimento;
        this.local = local;
        this.fornecedor = fornecedor;
        this.produto = produto;
        this.cdProduto = cdProduto;
        this.arquivos = arquivos;
        this.observacao = observacao;
        this.observacaoInutilizavel = observacaoInutilizavel;
        this.numeroSerie = numeroSerie;
        this.modelo = modelo;
        this.numeroNotaFiscal = numeroNotaFiscal;
    }
}